import { createApi } from '@core/fetch'

export default {
  getYouLikeList: createApi('/hms/light/adminApi/helpCenter/guessIssue'),
  getRelateCategory: createApi('/hms/light/adminApi/helpCenter/entryIcon')
}
